import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Button } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { getReferal, updateReferalDetail } from "../../services/Admin/adminServices";
import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import { debounce } from "lodash";

const CasesPage = () => {
const [cases, setCases] = useState([]);
const [loading, setLoading] = useState(false);
const [showModal, setShowModal] = useState(false);
const [selectedCase, setSelectedCase] = useState(null);
const [viewModal, setViewModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
      const [itemsPerPage, setItemsPerPage] = useState(10);
        const [totalItems, setTotalItems] = useState(0);
           const [search, setSearch] = useState("");
                      const [debouncedSearch, setDebouncedSearch] = useState("");
const navigate=useNavigate()
const svg1 = ( <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1"> <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <rect x="0" y="0" width="24" height="24"></rect> <circle fill="#000000" cx="12" cy="5" r="2"></circle> <circle fill="#000000" cx="12" cy="12" r="2"></circle> <circle fill="#000000" cx="12" cy="19" r="2"></circle> </g> </svg>
);

const fetchCases = async () => {
try {
setLoading(true);
 const res =await getReferal(currentPage,10,debouncedSearch)
      setTotalItems(res?.data?.data.total);
setCases(res?.data?.data?.caseReferrals );
} catch (error) {
console.error(error);
toast.error("Failed to load cases");
} finally {
setLoading(false);
}
};


 useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500); 
  
    handler();
  
    return () => {
      handler.cancel();
    };
  }, [search]);







useEffect(() => {
fetchCases();
}, [currentPage,debouncedSearch]);









const openModal = (caseItem) => {
setSelectedCase(caseItem);
setShowModal(true);
};

const openViewModal = (caseItem) => {
setSelectedCase(caseItem);
setViewModal(true);
};

  const CaseSchema = Yup.object().shape({
 
    currentStatus: Yup.string().required("Current status is required"),
    detailedStatus: Yup.string().required("Detailed status is required"),
    statusNotes: Yup.string().required("Status notes are required"),
  });

const handleSubmit = async(values) => {
try {
  await updateReferalDetail(values);
setShowModal(false);
fetchCases();
toast.success("Case updated successfully");

} catch (error) {
  console.error("error->", error);
  toast.error(error?.response?.data?.message);
}
};

    const totalPages = Math.ceil(totalItems / itemsPerPage);
return ( <div className="container mt-4">


<h2 style={{ color: "#0AB7EA" }}>Cases Management</h2>


 

    <div className="">
    <input
      type="text"
      style={{ borderRadius: "0.5rem", borderColor: "#0AB7EA" }}
      className="form-control w-100"
      placeholder="Search....."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
 
 
 








  {loading ? (
    <p>Loading...</p>
  ) : (
    <table className="table table-striped align-middle shadow-sm mt-3">
      <thead className="table-light">
        <tr>
          <th> Justice Centre</th>
           <th>    Referrer Name</th>
          

          <th> Referral Date</th>
          <th>   Incident Date</th>
          <th>Harmed Party</th>
              <th>Status</th>
          <th style={{ textAlign: "center" }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {cases?.length > 0 ? (
          cases.map((caseItem, index) => (
            <tr key={caseItem._id || index}>
              <td>{caseItem.justiceCentre}</td>
                        <td>{caseItem.nameOfReferrer}</td>
              <td>{new Date(caseItem.dateOfReferral).toLocaleDateString()}</td>
               <td>{new Date(caseItem.dateOfIncident).toLocaleDateString()}</td>
                           <td>{caseItem.harmedPartyName}</td>
                      <td>{caseItem.currentStatus}</td>
              <td style={{ textAlign: "center" }}>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    id={`dropdown-basic-${index}`}
                    style={{ padding: "4px 8px" }}
                  >
                    {svg1}
                  </Dropdown.Toggle>

               <Dropdown.Menu>
  <Dropdown.Item  onClick={()=>navigate(`/case-details/${caseItem._id}`)}>
    View
  </Dropdown.Item>
   
  <Dropdown.Item
    onClick={() => {
     openModal(caseItem);
    }}
  >
   Change Status
  </Dropdown.Item>
</Dropdown.Menu>

                </Dropdown>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="5" className="text-center">
              No cases found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )}

 
<Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Case Status</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            caseReferralId: selectedCase?._id || "",
            currentStatus: selectedCase?.currentStatus || "",
            detailedStatus: selectedCase?.detailedStatus || "",
            statusNotes: selectedCase?.statusNotes || "",
          }}
          enableReinitialize
          validationSchema={CaseSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <FormikForm>
              <Modal.Body>
              

                <div className="mb-3">
                  <label className="form-label">Current Status</label>
                  <Field
                    name="currentStatus"
                    as="select"
                    className="form-select"
                  >
                    <option value="">Select status</option>
                    <option value="Submitted">Submitted</option>
                    <option value="Intake Review">Intake Review</option>
                    <option value="Needs More Information">Needs More Information</option>


                      <option value="Not Eligible">Not Eligible</option>
                    <option value="Eligible">Eligible</option>
                    <option value="Assigned to Officer">Assigned to Officer</option>
                    
                      <option value="Scheduled">Scheduled</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Referred Externally">Referred Externally</option>

                      <option value="Withdrawn">Withdrawn</option>
                    <option value="Agreement Monitoring">Agreement Monitoring</option>
                    <option value="Agreement Reached">Agreement Reached</option>


                    <option value="Agreement Completed">Agreement Completed</option>
                    <option value="No Agreement">No Agreement</option>
                    <option value="Closed">Closed</option>
                      <option value="Archived">Archived</option>
                  </Field>
                  <ErrorMessage
                    name="currentStatus"
                    component="div"
                    className="text-danger"
                  />
                </div>



                <div className="mb-3">
                  <label className="form-label">Detailed Status</label>
                  <Field
                    name="detailedStatus"
                    as="select"
                    className="form-select"
                  >
                    <option value="">Select status</option>
                    <option value="Minimum Requirements Check">Minimum Requirements Check</option>
                    <option value="Eligibility Confirmed">Eligibility Confirmed</option>
                    <option value="Assigned & Acknowledged">Assigned & Acknowledged</option>


                      <option value="Contact Attempt 1">Contact Attempt 1</option>
                    <option value="Contact Attempt 2">Contact Attempt 2</option>
                    <option value="Contact Attempt 3">Contact Attempt 3</option>
                    
                      <option value="Unable to Contact">Unable to Contact</option>
                    <option value="Consent Obtained">Consent Obtained</option>
                    <option value="Pre-Session Preparation">Pre-Session Preparation</option>

                      <option value="Session Held">Session Held</option>
                    <option value="Agreement Drafted">Agreement Drafted</option>
                    <option value="Agreement Breach">Agreement Breach</option>


                    <option value="Follow-up Scheduled">Follow-up Scheduled</option>
                    <option value="Follow-up Completed">Follow-up Completed</option>
                    <option value="Deferred">Deferred</option>
                      <option value="Duplicate/Invalid">Duplicate/Invalid</option>
                  </Field>
                  <ErrorMessage
                    name="detailedStatus"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Status Notes</label>
                  <Field
                    name="statusNotes"
                    as="textarea"
                    className="form-control"
       
                    rows="3"
                  />
                  <ErrorMessage
                    name="statusNotes"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                  disabled={isSubmitting}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Changes"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>
  

   <div className="card-footer clearfix">
                          <div className="d-flex justify-content-between align-items-center">
                            <div
                              className="dataTables_info"
                              style={{ color: "#0AB7EA" }}
                            >
                              Showing {currentPage * itemsPerPage + 1} to{" "}
                              {totalItems > (currentPage + 1) * itemsPerPage
                                ? (currentPage + 1) * itemsPerPage
                                : totalItems}{" "}
                              of {totalItems} entries
                            </div>
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "10px" }}
                            >
                              <Pagination
                                pageCount={totalPages}
                                pageValue={currentPage}
                                setPage={setCurrentPage}
                              />
                            </div>
                          </div>
                        </div>








</div>
 

);
};

export default CasesPage;
